import {
  GetAdvertisersBudgetInfoArgs,
  GetAdvertisersByDayWidgetMetricsArgs,
  GetAdvertisersByDomainWidgetMetricsArgs,
  GetAdvertisersEpisodeLevelMetricsArgs,
} from 'api/services';

export const promoMetricsQueries = {
  all: ['metrics'] as const,
  daily: (args: GetAdvertisersByDayWidgetMetricsArgs) => [
    promoMetricsQueries.all,
    'daily',
    args,
  ],
  domain: (args: GetAdvertisersByDomainWidgetMetricsArgs) => [
    promoMetricsQueries.all,
    'domain',
    args,
  ],
  episodeLevel: (args: GetAdvertisersEpisodeLevelMetricsArgs) => [
    promoMetricsQueries.all,
    'episodeLevel',
    args,
  ],
  campaignBudget: (args: GetAdvertisersBudgetInfoArgs) => [
    promoMetricsQueries.all,
    'campaignBudget',
    args,
  ],
};
